import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/amirpay-logo.svg'


const _hoisted_1 = {
  class: "authentication",
  dir: "rtl"
}
const _hoisted_2 = { class: "authentication-card" }
const _hoisted_3 = { class: "authentication-security" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginFormComponent = _resolveComponent("LoginFormComponent")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "authentication-glow authentication-glow--top" }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "authentication-glow authentication-glow--bottom" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "سیارپی"
        })
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "authentication-intro" }, [
        _createElementVNode("p", { class: "authentication-eyebrow" }, "پنل مدیریت سیارپی"),
        _createElementVNode("h1", null, "خوش آمدید"),
        _createElementVNode("p", null, "برای ادامه، وارد حساب مدیریتی خود شوید.")
      ], -1)),
      (_ctx.authenticationStatus === 'login')
        ? (_openBlock(), _createBlock(_component_LoginFormComponent, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, [
        _createVNode(_component_v_icon, { size: "16" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("mdi-shield-check-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createTextVNode(" ورود امن و محافظت‌شده ", -1))
      ])
    ])
  ]))
}